import {
    PaperBtcUsdt,
    PaperExchange,
  } from "../../../../Const";
  
export const adaptBotPreset = (
  exchange = PaperExchange,
  exchangePair = PaperBtcUsdt,
) => {
  const pair = exchangePair.pair || {};
  
  return {
    id: null,
    name: "New Bot",
    exchange: exchange,
    exchangePairId: exchangePair.id, //exchange_pair.id
    pair: exchangePair.pair,
    initFund: 100,
    baseCoin: pair.from,
    quoteCoin: pair.to,
  };
};
export const adaptRentBotEdit = (
  bot
) => {
  const pair = bot.exchange_pair.pair || {};
  return {
    id: bot.id,
    rent_id: bot.rent_id,
    name: bot.name,
    exchange: bot.exchange_pair.exchange,
    exchangePairId: bot.exchange_pair_id, //exchange_pair.id
    pair: bot.exchange_pair.pair,
    initFund: bot.initial_fund,
    baseCoin: pair.from,
    quoteCoin: pair.to,
    strategy: bot.strategy,
    assetType: bot.exchange_pair.asset_type,
    minQuantity:bot.exchange_pair.min_quantity,
    pairMarginLevels:bot.exchange_pair.pair_margin_levels
  };
};
export const adaptRentBotDefault = (
  exchange = PaperExchange,
  exchangePair = PaperBtcUsdt,rental
) => {
  const pair = exchangePair.pair || {};
  return {
    id: null,
    name: "New Bot",
    exchange: exchange,
    exchangePairId: exchangePair.id, //exchange_pair.id
    pair: exchangePair.pair,
    initFund: 100,
    baseCoin: pair.from,
    quoteCoin: pair.to,
    rent_id: rental.id,
    pairMarginLevels:exchangePair.pair_margin_levels,
    minQuantity:exchangePair.min_quantity
  };
};
  